module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-position-relative"
  }, [_c('a', {
    staticClass: "uk-icon-link uk-link-text",
    attrs: {
      "href": "/cart",
      "uk-toggle": "target: #cart",
      "onclick": "return false"
    }
  }, [_c('span', {
    attrs: {
      "uk-icon": "icon: cart; ratio: 1.7"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uk-badge uk-margin-xsmall-left"
  }, [_vm._v(_vm._s(Object.keys(_vm.data.ShopOrderItems).length))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cart",
      "uk-offcanvas": "overlay: true; flip: true"
    }
  }, [_c('aside', {
    staticClass: "uk-offcanvas-bar uk-padding-remove"
  }, [_c('div', {
    staticClass: "uk-card uk-card-small uk-flex uk-flex-column uk-height-1-1"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "uk-margin-remove-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-card-body uk-card-small uk-overflow-auto uk-padding-remove-vertical"
  }, [_c('ul', {
    staticClass: "uk-list uk-list-divider tm-cart-sidebar-list"
  }, _vm._l((_vm.data.ShopItems), function(Product) {
    return _c('cart-navbar-item', {
      key: Product.ShopItem.id,
      attrs: {
        "product": Product,
        "shop-item-prices": _vm.data.ShopItemPrices[Product.ShopItem.id],
        "shop-item-warehouses": _vm.data.ShopItemWarehouses[Product.ShopItem.id],
        "shop-order-item": _vm.data.ShopOrderItems[Product.ShopItem.id]
      },
      on: {
        "update:shopOrderItem": function($event) {
          _vm.$set(_vm.data.ShopOrderItems, Product.ShopItem.id, $event)
        },
        "remove-from-cart": function($event) {
          _vm.removeFromCart(Product)
        }
      }
    })
  }))]), _vm._v(" "), _c('hr', {
    staticClass: "uk-margin-remove-bottom"
  }), _vm._v(" "), _c('footer', {
    staticClass: "uk-card-footer"
  }, [_c('div', {
    staticClass: "uk-text-lead uk-text-right"
  }, [_c('span', {
    staticClass: "uk-text-muted"
  }, [_vm._v("Сумма:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.cartAmount) + " руб.")])]), _vm._v(" "), _c('a', {
    staticClass: "uk-button uk-button-primary uk-button-primary-navbar-cart uk-width-1-1 uk-margin-small-top",
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("В\n                        корзину")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "uk-card-header"
  }, [_c('h3', {
    staticClass: "uk-card-title uk-margin-remove"
  }, [_vm._v("Корзина")]), _vm._v(" "), _c('button', {
    staticClass: "uk-offcanvas-close",
    staticStyle: {
      "top": "13px"
    },
    attrs: {
      "type": "button",
      "uk-close": "ratio: 1.7;"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbc909f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/Cart/CartNavbar.vue
// module id = 97
// module chunks = 0